import React from 'react';
import { PageLayout } from '@/shared/layout/PageLayout';
import { ZonesKpiDashboard } from './components/ZonesKpiDashboard';
import { ZonesModulesGrid } from './components/ZonesModulesGrid';
import { RecentZoneActivity } from './components/RecentZoneActivity';

export function ZonesDashboardPage() {
  return (
    <PageLayout
      title="Khu vực & Bản đồ (Zones & GIS)"
      description="Quản lý không gian, định vị GPS các phân khu và theo dõi tiến độ theo từng khu vực dự án"
    >
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">

        {/* Top KPIs Dashboard */}
        <ZonesKpiDashboard />

        {/* Navigation Hub */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-blue-500 rounded-full" />
                Quản lý Không gian (Space Management)
              </h3>
            </div>
            <div className="flex-1">
              <ZonesModulesGrid />
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-amber-500 rounded-full" />
                Hoạt động kiểm tra
              </h3>
              <button className="text-xs font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors cursor-pointer">
                Xem toàn bộ &rarr;
              </button>
            </div>
            <div className="flex-[2] flex flex-col min-h-0">
              <RecentZoneActivity />
            </div>

          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default ZonesDashboardPage;
